/* Cinematic PDP — Shipping Calculator & Countdown Timer
   Adapted from insigne-pro shipping module
   Reads config from window.__shipCfg (set in Liquid) */
function initShipping(){
  var cfg=window.__shipCfg||{};
  var tz=cfg.tz||'Europe/Istanbul';
  var cutoff=typeof cfg.cutoff==='number'?cfg.cutoff:9;
  var prodDays=typeof cfg.prodDays==='number'?cfg.prodDays:1;
  var transitMin=cfg.transitMin||2;
  var transitMax=cfg.transitMax||5;
  var prodWD=cfg.prodWeekdays||[1,2,3,4,5];
  var delWD=cfg.delWeekdays||[1,2,3,4,5];
  var rawH=cfg.holidaysRaw||'';
  var holidays=rawH.split(/[\n,]+/).map(function(h){return h.trim();}).filter(function(h){return /^\d{4}-\d{2}-\d{2}$/.test(h);});

  function nowInTZ(){
    var s=new Date().toLocaleString('en-US',{timeZone:tz});
    return new Date(s);
  }
  function fmtKey(d){return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');}
  function isHoliday(d){return holidays.indexOf(fmtKey(d))>=0;}
  function addBizDays(start,n,allowedDays){
    var d=new Date(start);var added=0;
    while(added<n){d.setDate(d.getDate()+1);if(allowedDays.indexOf(d.getDay())>=0&&!isHoliday(d))added++;}
    return d;
  }
  function nextAllowed(d,allowedDays){
    var c=new Date(d);
    while(allowedDays.indexOf(c.getDay())<0||isHoliday(c))c.setDate(c.getDate()+1);
    return c;
  }
  function fmtDate(d){return d.toLocaleDateString('en',{weekday:'short',month:'short',day:'numeric'});}
  function fmtShort(d){return d.toLocaleDateString('en',{month:'short',day:'numeric'});}

  /* Calculate dates */
  var now=nowInTZ();
  var pastCutoff=now.getHours()>=cutoff;
  var shipStart=new Date(now);
  if(pastCutoff)shipStart.setDate(shipStart.getDate()+1);
  if(prodDays>0)shipStart=nextAllowed(shipStart,prodWD);
  var shipDate=prodDays>1?addBizDays(shipStart,prodDays-1,prodWD):shipStart;
  var arriveMin=nextAllowed(addBizDays(shipDate,transitMin,delWD),delWD);
  var arriveMax=nextAllowed(addBizDays(shipDate,transitMax,delWD),delWD);

  /* Render arrival date */
  var ae=document.getElementById('cpdp-arrival-date');
  if(ae){
    ae.textContent=fmtKey(arriveMin)===fmtKey(arriveMax)?fmtDate(arriveMin):fmtShort(arriveMin)+' \u2013 '+fmtDate(arriveMax);
  }

  /* Render timeline */
  var tl=document.getElementById('cpdp-ship-timeline');
  if(tl){
    var steps=[
      {lbl:'Order',date:'Today',done:true,ico:'<svg viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'}
    ];
    if(prodDays>0)steps.push({lbl:'Production',date:fmtShort(shipStart),active:true,ico:'<svg viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>'});
    steps.push({lbl:'Shipped',date:fmtShort(shipDate),active:prodDays===0,ico:'<svg viewBox="0 0 24 24"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 4v4h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>'});
    steps.push({lbl:'Est. Delivery',date:fmtShort(arriveMin)+(fmtKey(arriveMin)!==fmtKey(arriveMax)?'\u2013'+fmtShort(arriveMax):''),ico:'<svg viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>'});
    var html='';
    steps.forEach(function(s){
      var cls='cpdp-ship-step';if(s.done)cls+=' done';
      var dotCls='cpdp-ship-dot';if(s.done)dotCls+=' done';else if(s.active)dotCls+=' active';
      html+='<div class="'+cls+'"><div class="'+dotCls+'"></div><div class="cpdp-ship-ico">'+s.ico+'</div><div class="cpdp-ship-lbl">'+s.lbl+'</div><div class="cpdp-ship-date">'+s.date+'</div></div>';
    });
    tl.innerHTML=html;
  }

  /* Countdown timer */
  function tick(){
    var n=nowInTZ();
    var cut=new Date(n);cut.setHours(cutoff,0,0,0);
    if(n>=cut)cut.setDate(cut.getDate()+1);
    var diff=cut-n;
    var h=Math.floor(diff/3600000),m=Math.floor(diff%3600000/60000),s=Math.floor(diff%60000/1000);
    var ce=document.getElementById('cpdp-countdown');
    if(ce)ce.textContent=String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(s).padStart(2,'0')+'s';
    /* Bar drains — starts full when new cycle begins, empties toward cutoff */
    var totalMs=24*3600000;
    var pct=Math.max(2,Math.min(100,(diff/totalMs)*100));
    var fe=document.getElementById('cpdp-timer-fill');
    if(fe){
      fe.style.width=pct+'%';
      var cls='cpdp-timer-fill ';
      if(h<1) cls+='urgent';
      else if(h<4) cls+='warning';
      else cls+='normal';
      fe.className=cls;
    }
    /* Update countdown text color based on urgency */
    if(ce){
      if(h<1) ce.style.color='#e05555';
      else if(h<4) ce.style.color='#e8a33d';
      else ce.style.color='#d7b186';
    }
  }
  tick();setInterval(tick,1000);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initShipping);}else{initShipping();}
